
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-6">
              About SALONASPED d.o.o.
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              SALONASPED d.o.o. is a technology company based in Croatia, dedicated to developing innovative applications that enhance digital security and user experience. Our flagship VPN application represents our commitment to protecting user privacy in an increasingly connected world.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              We believe that everyone deserves access to a free and open internet without compromising their privacy or security. Our VPN solution is built with this philosophy in mind, combining cutting-edge encryption technology with an intuitive user interface.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Located in Solin, Croatia, our team of experienced developers and security experts work tirelessly to ensure that our VPN service meets the highest standards of performance, reliability, and security.
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/af355b9f1a36380d4e8489b0165ef0f2.jpg"
              alt="SALONASPED d.o.o. Office"
              className="rounded-xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
